import { useEffect, useReducer } from "react";

import { AWSPlace, FPAPISuccessStatus, getFPPlace } from "/geoservice";
import { useMounted } from "/hook";
import { reducer } from "/util";

import { State } from "./usePlaceDetails.types";
const usePlaceDetails = (placeId: string): State => {
  const [state, dispatch] = useReducer(reducer.reducer, reducer.initialState);
  const mountedRef = useMounted();

  useEffect(() => {
    dispatch({ type: reducer.actionTypes.INIT });
  }, []);

  useEffect(() => {
    if (!mountedRef.current) {
      return;
    }

    if (!placeId) {
      dispatch({ type: reducer.actionTypes.INIT });
      return;
    }

    dispatch({ type: reducer.actionTypes.LOADING });

    getFPPlace(placeId, (placeDetails: AWSPlace, status: string) => {
      if (mountedRef.current) {
        if (!placeDetails || status !== FPAPISuccessStatus) {
          dispatch({ type: reducer.actionTypes.FAILURE });
        } else {
          dispatch({ payload: placeDetails, type: reducer.actionTypes.SUCCESS });
        }
      }
    });
  }, [placeId]);

  return state as State;
};

export default usePlaceDetails;
